import ServiceContainer from "./ServiceContainer/ServiceContainer";
import dairy from './photos/dairy.jpeg'
import beef from './photos/beef.jpeg'
import pig from './photos/pig.jpeg'
import sheep from './photos/sheep.jpeg'
import poultry from './photos/poultry.jpeg'
import sheepIcon from './photos/sheep-icon.png'
import cowIcon1 from './photos/cow-icon1.png'
import cowIcon2 from './photos/cow-icon2.png'
import pigIcon from './photos/pig-icon.png'
import chicken from './photos/chicken.jpeg'
import chickenIcon from './photos/chicken-icon.png'
import logo from "../../photos/mini-pageIcon.png";
import farmIcon from './photos/Farm2.png'



import beef_doc_template from "./security_templates/biosecurity-plan-template-beef.pdf"
import beef_pdf_checklist from "./security_templates/biosecurity-checklist-beef.pdf"
import beef_enhanced_template from './security_templates/enhanced-biosecurity-template-beef.docx'

import dairy_doc_template from "./security_templates/biosecurity-plan-template-dairy.docx"
import dairy_pdf_checklist from "./security_templates/biosecurity-checklist-dairy.pdf"
import dairy_enhanced_template from './security_templates/enhanced-biosecurity-plan-template-dairy.docx'

import general_doc_template from "./security_templates/biosecurity-plan-template-general.docx"
import general_pdf_checklist from "./security_templates/biosecurity-checklist-general.pdf"


import poultry_doc_template from "./security_templates/biosecurity-plan-template-poultry.docx"
import poultry_pdf_checklist from "./security_templates/biosecurity-checklist-poultry.pdf"

import sheep_doc_template from "./security_templates/biosecurity-plan-template-sheep.docx"
import sheep_pdf_checklist from "./security_templates/biosecurity-checklist-sheep.pdf"
import sheep_enhanced_template from "./security_templates/enhanced-biosecurity-template-sheep.docx"


import swine_doc_template from "./security_templates/biosecurity-plan-template-swine.docx"
import swine_pdf_checklist from "./security_templates/biosecurity-checklist-swine.pdf"
import swine_enhanced_indoor_template from './security_templates/enhanced-biosecurity-plan-template-swine-indoors.docx'
import swine_enhanced_outdoor_template from './security_templates/enhanced-biosecurity-plan-template-swine-outdoors.docx'


import './ServiceList.css'
const ServiceList = () => {
    return (
        <div className = 'service-list'>
            <div className= 'div-header'>
                <div className= 'page-mini-logo'>
                    <img alt = 'logo' src = {logo}/>
                </div>
                <h1> Biosecurity Resources </h1>
                <h2> Checklists & Biosecurity Plan Templates </h2>
            </div>
            <div className= 'all-service'>

                <ServiceContainer img = {chicken} icon = {farmIcon} type = "General (Livestock & Poultry)"
                                  desc = "Lorem ium dolor sit ametad pisicing elit sed simply do ut."
                                  template = {general_doc_template}
                                  template_name = "Biosecurity Plan Template (CFSPH)"
                                  checklist = {general_pdf_checklist}
                                  checklist_name = "Checklist (CFSPH)"
                />

                <ServiceContainer img = {beef} icon = {cowIcon1} type = "Beef Cattle"
                                  desc = "Lorem ium dolor sit ametad pisicing elit sed simply do ut."
                                  template = {beef_doc_template}
                                  template_name = "Biosecurity Plan Template (CFSPH)"
                                  checklist = {beef_pdf_checklist}
                                  checklist_name = "Checklist (CFSPH)"
                                  enhanced_template_name = "Enhanced Biosecurity Plan Template (SBS)"
                                  enhanced_template = {beef_enhanced_template}

                />

                <ServiceContainer img = {dairy} icon = {cowIcon2} type = "Dairy Cattle"
                                  desc = "Lorem ium dolor sit ametad pisicing elit sed simply do ut."
                                  template = {dairy_doc_template}
                                  template_name = "Biosecurity Plan Template (CFSPH)"
                                  checklist = {dairy_pdf_checklist}
                                  checklist_name = "Checklist (CFSPH)"
                                  enhanced_template_name = "Enhanced Biosecurity Plan Template (SMS)"
                                  enhanced_template = {dairy_enhanced_template}

                />

                <ServiceContainer img = {sheep} icon = {sheepIcon} type = "Sheep"
                                  desc = "Lorem ium dolor sit ametad pisicing elit sed simply do ut."
                                  template = {sheep_doc_template}
                                  template_name = "Biosecurity Plan Template (CFSPH)"
                                  checklist = {sheep_pdf_checklist}
                                  checklist_name = "Checklist (CFSPH)"
                                  enhanced_template_name = "Enhanced Biosecurity Plan Template (SSWS)"
                                  enhanced_template = {sheep_enhanced_template}
                />

                <ServiceContainer img = {pig} icon = {pigIcon} type = "Swine"
                                  desc = "Lorem ium dolor sit ametad pisicing elit sed simply do ut."
                                  template = {swine_doc_template}
                                  template_name = "Biosecurity Plan Template (CFSPH)"
                                  checklist = {swine_pdf_checklist}
                                  checklist_name = "Checklist (CFSPH)"
                                  enhanced_template_name = "Enhanced Biosecurity Plan Template – Indoor Production (SPS)"
                                  enhanced_template = {swine_enhanced_indoor_template}
                                  second_enhanced_template_name = "Enhanced Biosecurity Plan Template – Indoor-Outdoor Production (SPS)"
                                  second_enhanced_template = {swine_enhanced_outdoor_template}
                                  // enhanced_template = {swine_enhanced_outdoor_template}
                />


                <ServiceContainer img = {poultry} icon = {chickenIcon} type = "Poultry"
                                  desc = "Lorem ium dolor sit ametad pisicing elit sed simply do ut."
                                  template = {poultry_doc_template}
                                  template_name = "Biosecurity Plan Template (Poultry Biosecurity)"
                                  checklist = {poultry_pdf_checklist}
                                  checklist_name = "Checklist (Poultry Biosecurity)"
                />

            </div>
        </div>
    )
}
export default ServiceList;